import { createContext, ReactNode, useContext, useState } from 'react';
import { VIEW_TYPE_CONFIG } from '../constants';

type Context = {
	selectedPatient: any;
	setSelectedPatient: (data: any) => void;
	patientInfo: any;
	setPatientInfo: (data: any) => void;
	statusChange: boolean;
	setStatusChange: (data: boolean) => void;
	viewType: string;
	setViewType: (data: string) => void;
};

type ContextProviderProps = {
	children: ReactNode;
};

const PhanHeBaoHiemYTeContext = createContext<Context>({
	selectedPatient: {},
	setSelectedPatient() {},
	patientInfo: {},
	setPatientInfo() {},
	statusChange: false,
	setStatusChange() {},
	viewType: '',
	setViewType() {},
});

export const PhanHeBaoHiemYTeContextProvider = ({ children }: ContextProviderProps) => {
	const [selectedPatient, setSelectedPatient] = useState<any>();
	const [patientInfo, setPatientInfo] = useState<any>();
	const [statusChange, setStatusChange] = useState<boolean>(false);
	const [viewType, setViewType] = useState<string>('');

	return (
		<PhanHeBaoHiemYTeContext.Provider
			value={{
				selectedPatient,
				setSelectedPatient,
				patientInfo,
				setPatientInfo,
				statusChange,
				setStatusChange,
				viewType,
				setViewType,
			}}
		>
			{children}
		</PhanHeBaoHiemYTeContext.Provider>
	);
};

export const usePhanHeBaoHiemYTeContext = () => useContext(PhanHeBaoHiemYTeContext);
